import {isMobile} from '../caps'

let songTitle;
let lastSongTitleElement;
let songTitleElement;
let delay = 60;
let titleIndex = 0;
let scrollTimeout = null;
let rollOutInterval = null;
let rollInInterval = null;
let rolloutDone = false;
let stopScrollingRequested = false;
let _setSharedState = null;

const separator = '\u00A0\u00A0-\u00A0\u00A0';
const space =  '\u00A0\u00A0';

let $title = '';
let titleSetCallback = null;
export const registerTitleSetCallback = cb => titleSetCallback = cb;
export const getTitle = () => { return $title; };
const setTitle = title => {
    document.title = $title = title;
    titleSetCallback?.(title);
};

function startScrollingTitle(title, setSharedState) {
    if (!title) return;
    stopScrollingRequested = false;
    _setSharedState = setSharedState;

    songTitleElement = title?.trim().replaceAll('\n', '').replaceAll('\r', '')
            .replace('7  €  X  .  L  €  X  3  R', '7€X.L€X3R'.split('').join(space))
            .replace('7 € X . L € X 3 R', '7€X.L€X3R'.split('').join(space))
            .replace('L € X 3 R . $', 'L€X3R.$'.split('').join(space))
            .replace('. ¥', '.¥'.split('').join(space))
            .replace(' - ', separator);

    if (lastSongTitleElement === songTitleElement) {
        return;
    }

    lastSongTitleElement = songTitleElement;

    if (rollOutInterval) {
        clearInterval(rollOutInterval);
        rollOutInterval = null;
    }
    if (scrollTimeout) {
        clearTimeout(scrollTimeout);
        scrollTimeout = null;
    }
    if (rollInInterval) {
        clearInterval(rollInInterval);
        rollInInterval = null;
    }

    songTitle = space + songTitleElement;
    const mobileLength = 256;
    const desktopLength = Math.min(songTitleElement.length * 3, songTitleElement.length * Math.ceil(150 / songTitleElement.length))
    while (songTitle.length < Math.min(256, isMobile() ? mobileLength : desktopLength)) {
        songTitle += separator + songTitleElement;
    }

    stopScrollingTitle(setSharedState);

    rolloutTitle(() => {
        titleIndex = -1;
        scrollTitle();
    })
}

function rolloutTitle(callback) {
    let currentLength = 1;
    let maxChars = songTitle.length;

    rollInInterval = setInterval(() => {
        setTitle(songTitle.substring(0, currentLength));
        currentLength++;

        if (rolloutDone) {
            rolloutDone = false;
            maxChars = currentLength;
            songTitle = space + (songTitleElement + separator)
                .repeat(Math.floor(maxChars / songTitleElement.length) + 1)
                .slice(0, -separator.length);
        }

        _setSharedState(state => !state.isTitleScrolling ? ({...state, isTitleScrolling: true}): state);

        if (currentLength <= maxChars) {
            setTitle(songTitle.substring(0, currentLength));
            currentLength += 3;
        } else {
            clearInterval(rollInInterval);
            rollInInterval = null;
            if (callback) callback();
        }
    }, delay);
}

function scrollTitle() {
    if (stopScrollingRequested && (
        getTitle().startsWith(songTitleElement)
        || getTitle().startsWith(space + songTitleElement)
    )) {
        stopScrollingRequested = false;
        if (scrollTimeout) {
            clearTimeout(scrollTimeout);
            scrollTimeout = null;
        }
        if (rollInInterval) {
            clearInterval(rollInInterval);
            rollInInterval = null;
        }
        _setSharedState(state => !!state.isTitleScrolling ? ({...state, isTitleScrolling: false}): state);
        lastSongTitleElement = null;
        rolloutTitleReverse();
    } else {
        let currentTitleIndex = titleIndex % ((songTitle + separator).length);
        setTitle((songTitle + separator).substring(currentTitleIndex)
            + songTitle.substring(0, currentTitleIndex));
        titleIndex++;
        scrollTimeout = setTimeout(scrollTitle, delay);
    }
}

function rolloutTitleReverse() {
    if (getTitle().endsWith(separator)) {
        setTitle(getTitle().slice(0, -separator.length));
    }
    rollOutInterval = setInterval(() => {
        setTitle(getTitle().substring(1) || '⠀');
        if (getTitle() === '⠀' || getTitle().trim().length === 0) {
            setTitle('‎‪ليكسر');
            clearInterval(rollOutInterval);
            rollOutInterval = null;
        }
    }, delay);
}

function stopScrollingTitle(setSharedState) {
    _setSharedState = setSharedState;
    if (rollInInterval) {
        stopScrollingRequested = true;
    }
    if (scrollTimeout) {
        stopScrollingRequested = true;
    }
}

function markRolloutDone() {
    rolloutDone = true;
}

function isTitleScrolling() {
    return !!scrollTimeout || !!rollOutInterval;
}

export {
    startScrollingTitle,
    stopScrollingTitle,
    markRolloutDone,
    isTitleScrolling,
}
